import React from "react";
import CompileShaders from "./CompileShaders";

const PreRenderLogic = () => {
  return <CompileShaders />;
};

export default PreRenderLogic;
